import { SVG_ICONS } from './icons';

export const XIcon = SVG_ICONS.close;
